import templateUrl from "servicestack/auto-query/auto-query-header.htm";
import searchTemplateUrl from "servicestack/auto-query/auto-query-header.search.htm";
import Controller from "servicestack/auto-query/auto-query-header.controller";

export default {
	bindings: {
		onToggleLeftNav: "&?",
		onToggleGalleryView: "&?",
		query: "<",
		hideFilter: "@",
		searchLabel: "@",
		onSearch: "&",
		onCleared: "&",
		addButtonLabel: "@",
		addLabel: "@",
		bulkButtonLabel: "@",
		bulkButtonIcon: "@",
		focusSearchOn: "@",
		onAdd: "&",
		onBulk: "&",
		filterLabel: "@",
		onFilter: "&",
		hideSearch: "<?",
		hidePageInfo: "<?",
		hidePageSizes: "<?",
		hideClearButton: "<?",
		hideSortOptions: "<?",
		hideMessages: '<',
		hideViews: "<?",
		exportButtonLabel: "@",
		exportTemplate: "@",
		exportOrigin: "@",
		exportFilename: '@'

	},
	controller: Controller,
	templateUrl($element, $attrs) {
		return (
			$attrs.templateUrl || ($attrs.search ? searchTemplateUrl : templateUrl)
		);
	},
	transclude: {
		left: "?headerLeft",
		middle: "?headerMiddle",
		right: "?headerRight",
		rightPre: "?headerRightPre",
		rightPost: "?headerRightPost"
	}
};
